/** Same query contract for the history table and the forthcoming export job. */
export interface HistoryQuery {
  startDate?: string;
  endDate?: string;
  brandId?: number;
  branchId?: number;
  branchIds?: string;
  driverIds?: string;
  status?: string;
  searchTerm?: string;
  page?: number;
  pageSize?: number;
}

export function historyQueryString(
  query: HistoryQuery,
  includePagination = true,
): string {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(query)) {
    if (!includePagination && (key === "page" || key === "pageSize")) continue;
    if (value === undefined || value === "" || value === "all") continue;
    params.set(key, String(value));
  }
  return params.toString();
}
